import { useCallback, useRef } from 'react';
import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';
import { useQuestionnaireFormContext } from '@/components/Questionnaire/QuestionnaireProvider';
import Button from '@/components/DesignLibrary/Button';

type Props = {
  rowFieldKey: string;
  onClick: (args: {
    newValue:
      & {
        _id: string;
        _associatedField: string | null;
      }
      & Record<string, unknown>
    responseSources: Record<string, QuestionnaireApiModels.QuestionnaireResponse['source']>;
    aiRequestIds: Record<string, string | null>;
    autofillStatuses: Record<string, boolean>;
  }) => void;
};

const SaveButton: React.FC<Props> = ({ onClick, rowFieldKey }) => {
  const {
    formMethods: modalFormMethods,
    getBulkResponseSources: modalGetRowResponseSources,
    getBulkAiRequestIds: modalGetRowAiRequestIds,
    getBulkAutofillStatuses: modalGetRowAutofillStatuses,
  } = useQuestionnaireFormContext();
  const onClickRef = useRef(onClick);
  onClickRef.current = onClick;

  const handleClick = useCallback((): void => {
    const newValue = modalFormMethods.getValues(rowFieldKey);
    const responseSources = modalGetRowResponseSources({ rowFieldKey });
    const aiRequestIds = modalGetRowAiRequestIds({ rowFieldKey });
    const autofillStatuses = modalGetRowAutofillStatuses({ rowFieldKey });
    onClickRef.current({ aiRequestIds, autofillStatuses, newValue, responseSources });
  }, [modalFormMethods, rowFieldKey, modalGetRowResponseSources, modalGetRowAiRequestIds, modalGetRowAutofillStatuses]);

  // @TODO - put back to "Save", this is there to distinquish between the two modes
  return (
    <Button
      variant="primary"
      size="md"
      onClick={handleClick}
    >
      Save Changes
    </Button>
  );
};

export default SaveButton;